function Close() {
  let errorContainer = document.getElementById('error-container');
  if (errorContainer.hasChildNodes()) {
    errorContainer.removeChild(errorContainer.lastChild);
  }
}

export default Close;
